import axios from "axios";
import Environment from "./Environment";

const URL = Environment.findString("REACT_APP_API_ORIGIN");
const Api = axios.create({ baseURL: URL });

export default Api;
